import React, { useEffect } from "react";

export const useFootballSocket = ({
    socket,
    channel,
    event,
    setData,
    type,
    allowedLeagues
}) => {

    useEffect(() => {
        if (!socket || !allowedLeagues?.length) return;
        else {
            socket?.channel(channel)?.listen(event, (e) => {
                const rawData = e?.data;
                let socketData = allowedLeagues ? rawData.filter(l => allowedLeagues?.includes(l.lid)) : rawData;

                setData((prevState) => {
                    let nextState = [];
                    prevState?.forEach((l) => {
                        let tempLeague = socketData?.find((x) => x.id === l.id);

                        if (!tempLeague) {
                            nextState?.push(l);
                        } else {
                            let updatedLeague = { ...l, matches: [] };

                            l?.matches?.forEach((m) => {
                                let tempMatch = tempLeague?.matches?.find((x) => x.id === m.id);
                                if (!tempMatch) {
                                    updatedLeague?.matches.push(m);
                                } else {
                                    updatedLeague?.matches.push({
                                        ...m,
                                        st: tempMatch?.st ?? m?.st,
                                        cfs: tempMatch?.cfs ?? m?.cfs,
                                        ft: tempMatch?.ft ?? m?.ft,
                                        ht: tempMatch?.ht ?? m?.ht,
                                        et: tempMatch?.et ?? m?.et,
                                        ps: tempMatch?.ps ?? m?.ps,
                                        cp: tempMatch?.ps ?? m?.cp,
                                        f_time: tempMatch?.f_time ?? m?.f_time,
                                        sut: tempMatch?.sut ?? m?.sut,
                                        sun: tempMatch?.sun ?? m?.sun,
                                        odds: tempMatch?.odds ?? m?.odds,
                                    });
                                }
                            });

                            // Add new matches for live events
                            tempLeague?.matches?.forEach((m) => {
                                let tempMatch = l?.matches?.find((x) => x.id === m.id);
                                if (!tempMatch) {
                                    updatedLeague.matches.push(m);
                                }
                            });

                            nextState.push(updatedLeague);
                        }
                    });

                    // Add any new leagues (live only)
                    socketData?.forEach((l) => {
                        let tempLeague = prevState?.find((x) => x.id === l.id);
                        if (!tempLeague) {
                            nextState.push(l);
                        }
                    });

                    // Remove finished/canceled leagues or matches
                    nextState = nextState?.map((l) => {
                        const finishedMatches = l?.matches?.filter((m) =>
                            [
                                "finished",
                                "finished ap",
                                "finished aet",
                                "awarded",
                                "cancelled",
                                "postponed",
                                "abandoned",
                                "deleted",
                                "result only",
                            ].includes(m?.st?.toLowerCase())
                        );
                        if (finishedMatches?.length === l?.matches?.length) {
                            return { ...l, removeLeague: "true" };
                        } else {
                            const finishedMatchIds = finishedMatches?.map((m) => m?.id);
                            return {
                                ...l,
                                matches: l.matches.map((m) =>
                                    finishedMatchIds.includes(m.id)
                                        ? { ...m, removeMatch: "true" }
                                        : m
                                ),
                            };
                        }
                    });

                    return nextState;
                });
            });

            return () => {
                socket?.channel(channel)?.stopListening(event);
                socket?.connector?.socket?.disconnect();
            };
        }
    }, [socket, channel, event, setData, type, allowedLeagues]);
};
